<template>
    <div id="maarima-logo" ref="MaariMaLogo">
        <transition name="translate" mode="out-in">
            <component :is="componentName" :theme="_theme" :icon-only="iconOnly" />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MaariMaLogoDefault from './maarima/MaariMaLogoDefault.vue'
import MaariMaLogoIcon from './maarima/MaariMaLogoIcon.vue'
import MaariMaLogoTaglineStrip from './maarima/MaariMaLogoTaglineStrip.vue'
import MaariMaLogoTaglineStack from './maarima/MaariMaLogoTaglineStack.vue'

const taglineOptions = ['none', 'stack', 'strip']
const themeOptions = ['default', 'light', 'dark', 'black', 'white']

export default {
    name: 'maarima-logo',
    props: {
        tagline: {
            type: String,
            validate: (v) => taglineOptions.contains(v),
            default: taglineOptions.first()
        },
        iconOnly: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            validate: (v) => themeOptions.contains(v),
            default: themeOptions.first()
        }
    },
    components: {
        MaariMaLogoDefault,
        MaariMaLogoIcon,
        MaariMaLogoTaglineStrip,
        MaariMaLogoTaglineStack
    },
    computed: {
        ...mapGetters({
            themeMode: 'user/themeMode'
        }),
        _theme() {
            if (this.theme == 'default') {
                return this.themeMode
            }
            return this.theme
        },
        componentName() {
            if (this.tagline != 'none') {
                return `maariMa-logo-tagline-${this.tagline}`
            }
            if (this.iconOnly) {
                return 'maariMa-logo-icon'
            }
            return 'maariMa-logo-default'
        }
    }
}
</script>

<style lang="scss" scoped>
.translate-enter-active,
.translate-leave-active {
    transition: all 0.5s ease;
}

.translate-enter-from,
.translate-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
